import {inject, Injectable} from '@angular/core';
import {ConfigurationService} from "../../shared/services/configuration.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {map, Observable, tap} from "rxjs";
import {RealmModel} from "../models/realm.model";

@Injectable({
  providedIn: 'root'
})
export class RealmService{
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject(ConfigurationService).configuration;

  private readonly realmProperty: string = 'realm';
  private readonly mailProperty: string = 'mail';
  private readonly realmEndpoint = this.config.api.endpoints.realm;
  private readonly api = this.config.api.backendUrl;
  private readonly realmToken = this.config.api.realmToken;

  getRealmFromMail(mail: string): Observable<RealmModel> {
    const headers = new HttpHeaders().set('x-api-key', this.realmToken);

    return this.httpClient.get<RealmModel>(
      `${this.api}/${this.realmEndpoint}/user?mail=${mail}`,
      {headers}
    ).pipe(
      map((realm: RealmModel) => {
        realm.mail = mail;
        return realm;
      }),
      tap((realm: RealmModel) => {
        this.realm = realm.realm;
        this.mail = realm.mail;
      })
    );
  }

  public set realm(_realm: string) {
    localStorage.setItem(this.realmProperty, _realm);
  }

  public get realm(): string | null {
    return localStorage.getItem(this.realmProperty)
  }

  public set mail(_mail: string) {
    localStorage.setItem(this.mailProperty, _mail);
  }

  public get mail(): string | null {
    return localStorage.getItem(this.mailProperty);
  }

  async clearStorage() {
    localStorage.removeItem(this.realmProperty);
    localStorage.removeItem(this.mailProperty);
  }
}
